import React from 'react';
import {connect} from "react-redux";
import AuthService from "../../../../../../services/AuthService";
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import {
    getProjetsPro
}from './../../../../../../actions/entreprise/actions_entreprise_entretien';
import moment from "../../../../../shared/utils/moment_fr";

class CompetencesTable extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            t1AutoComplete:[],
        };
        this.Auth = new AuthService();
        this.fetchProjetsPro = this.fetchProjetsPro.bind(this);
        this.deleteProjetPro = this.deleteProjetPro.bind(this);
        this.handleNewProjetPro = this.handleNewProjetPro.bind(this);
    }

    handleNewProjetPro(x){
        const eh = this.props.entretienHeader;
        this.Auth.fetch('/salarie/competences',{
            method:'POST',
            data:{
                id_salarie: eh.id_salarie,
                id_entretien: eh.id,
                id_entreprise: eh.id_entreprise,
                competence:x
            }
        }).then( x=>{
            this.fetchProjetsPro();
            this.setState({t1Open:true})
        });
    }

    fetchProjetsPro(){
        const id_entretien = this.props.entretienHeader.id;
        this.props.dispatch(getProjetsPro(id_entretien));
    }

    deleteProjetPro(id){
        this.Auth.fetch(`/salarie/projet_pro/${id}`,{
            method:'delete'
        }).then(x=>this.fetchProjetsPro());
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.entretienHeader !== this.props.entretienHeader )
            this.fetchProjetsPro();
    }
    componentDidMount(){
        if(this.props.entretienHeader && this.props.entretienHeader.id){
            this.fetchProjetsPro();
        }
        this.Auth.fetch('/societe/competences')
            .then(x=> this.setState({t1AutoComplete:x.data.payload}))
    }



    render() {
        if(this.props.projets_pro.length === 0)
            return null;

        return (
            <div>
                <table className="table table-sm table-bordered table-hover" style={{fontSize:11}}>
                    <thead className="thead-light" style={{cursor:'pointer'}}>
                    <tr>
                        <th>Projets professionnels définis</th>
                        <th>Échéances des projets</th>
                        <th>Domaines d'activités visés</th>
                        <th>Compétences à développer</th>
                        <th>Moyens à mobiliser</th>
                        <th>Période de réalisation prévue</th>
                        <th width="22px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.projets_pro.map(x=>{
                        return (
                            <tr key={x.id}>
                                <td>{x.projet_pro_defini}</td>
                                <td>{x.echeance}</td>
                                <td>{x.domaine_activite_visee}</td>
                                <td>{x.competences_a_developper}</td>
                                <td dangerouslySetInnerHTML={{__html:x.moyens_a_mobiliser}}></td>
                                <td>{
                                moment(x.Date_debut).format('DD/MM/YYYY')
                                +' - '
                                + moment(x.Date_fin).format('DD/MM/YYYY')}</td>
                                <td style={{cursor:'pointer'}} onClick={()=>this.deleteProjetPro(x.id)}><DeleteIcon color='red'/></td>
                            </tr>);
                        })}
                        </tbody>
                </table>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader: store.entretien.header,
        projets_pro: store.entretien.projets_pro
    }
}

export default connect(mapStateToProps)(CompetencesTable);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/comps/ProjetProTable.js